import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import cubeIcon from 'images/discover/datasets/cube.svg'
import gridIcon from 'images/discover/datasets/grid.svg'
import shieldTickIcon from 'images/discover/datasets/shield-tick.svg'
import slidersIcon from 'images/discover/datasets/sliders.svg'

const FEATURE_ICONS = [gridIcon, cubeIcon, slidersIcon, shieldTickIcon]

function Features({ features }) {
  return (
    <section className="datasets-features">
      <div className="discover-container">
        <h2 className="datasets-section-title discover-heading cgt-heading-500">{features.title}</h2>
        <ul className="datasets-features__list">
          {features.items.map((item, index) => (
            <li key={item.title} className="datasets-features__card">
              <img src={FEATURE_ICONS[index]} alt="" width={40} height={40} loading="lazy" />
              <h3 className="datasets-features__card-title discover-heading cgt-heading-200">{item.title}</h3>
              <p className="datasets-features__card-text cgt-body-md">{item.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

Features.propTypes = {
  features: shape({
    title: string.isRequired,
    items: arrayOf(shape({ title: string.isRequired, text: string.isRequired })).isRequired,
  }).isRequired,
}

export default Features
